(() => {
  const breakpoint = window.matchMedia('(min-width: 750px)');
  const target = document.querySelector('[data-fp-product-left-extras]');
  if (!target || window.Shopify?.designMode) return;

  const candidates = [
    document.querySelector('product-recommendations[data-intent="related"]')?.closest('.shopify-section'),
    document.querySelector('fp-recently-viewed')?.closest('.shopify-section'),
  ].filter(Boolean);

  const placeholders = new Map();
  candidates.forEach((section) => {
    const placeholder = document.createComment('fp-product-section-placeholder');
    section.parentNode?.insertBefore(placeholder, section);
    placeholders.set(section, placeholder);
  });

  const update = () => {
    candidates.forEach((section) => {
      if (breakpoint.matches) {
        target.append(section);
      } else {
        const placeholder = placeholders.get(section);
        placeholder?.parentNode?.insertBefore(section, placeholder.nextSibling);
      }
    });
  };

  update();
  breakpoint.addEventListener?.('change', update);
})();
